import logo from './logo.svg';
import './App.css';
import Board from './Board';
import Node from './Node';

function App() {
    let nInitial = new Node(2,2);
    let nFinal = new Node(12,15);

    return (    
        <div className="App">
            <h1>A* Pathfinding</h1>
            <Board  initialNode={nInitial} finalNode={nFinal}/>
        </div>
    );
}

// in future versions allow to change start and final positions
function getNewPositions() {
    let posInitial = document.getElementById("newInitial").value;
    let posFinal = document.getElementById("newFinal").value;

    posInitial = posInitial.split('-');
    let nInitial = new Node(posInitial[0], posInitial[1]);

    posFinal = posFinal.split('-');
    let nFinal = new Node(posFinal[0], posFinal[1]);

    return {initial: nInitial, final: nFinal};
}

export default App;
